import { cn } from "@/lib/utils";
import {
  Box,
  Building2,
  Circle,
  CreditCard,
  List,
  type LucideIcon,
  School,
  Settings,
  Smartphone,
  Sprout,
  Stethoscope,
  User,
  Users,
} from "lucide-react";

const RADIO_ICON_MAP: Record<string, LucideIcon> = {
  user: User,
  users: Users,
  list: List,
  "kit-medical": Stethoscope,
  seedling: Sprout,
  school: School,
  building: Building2,
  "credit-card": CreditCard,
  mobile: Smartphone,
  box: Box,
  cog: Settings,
};

interface IRadioBoxProps {
  icon: string;
  title: string;
  className?: string;
  value?: number | string;
  currentValue?: number | string;
  onClick: (value: number | string) => void;
}

const RadioBoxAurora = (props: IRadioBoxProps) => {
  const { icon, title, className, value, currentValue, onClick } = props;

  const selected = value === currentValue;
  const IconComp = RADIO_ICON_MAP[icon] ?? Circle;

  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={() => value !== undefined && onClick(value)}
      className={cn(
        "group flex w-full flex-col items-center justify-center gap-2 rounded-2xl border bg-white px-4 py-5 text-center transition-all duration-200 dark:bg-zinc-900",
        selected
          ? "border-primary shadow-[0_0_0_3px_rgba(99,102,241,0.14)] ring-1 ring-primary/40"
          : "border-slate-200/80 hover:border-primary/50 dark:border-zinc-800",
        className
      )}
    >
      <IconComp
        className={cn(
          "h-6 w-6 transition-colors",
          selected ? "text-primary" : "text-slate-400 dark:text-zinc-500"
        )}
      />
      <span
        className={cn(
          "text-sm font-semibold transition-colors",
          selected ? "text-primary" : "text-slate-600 dark:text-zinc-300"
        )}
      >
        {title}
      </span>
    </button>
  );
};

export default RadioBoxAurora;
